import { createFileRoute, redirect } from '@tanstack/react-router';

import { RolesLayout } from '@/features/admin/roles/RolesLayout';
import { ErrorBoundary, ErrorFallback } from '@/modus/ErrorBoundary';
import { userHasRole } from '@/utils/roles';

export const Route = createFileRoute('/_protected/t/$tenantId/admin/roles')({
  beforeLoad: ({ context }) => {
    if (!userHasRole(context.user, 'admin')) {
      throw redirect({ to: '/' });
    }
  },
  component: RolesRoute,
});

function RolesRoute() {
  return (
    <ErrorBoundary fallback={(error) => <ErrorFallback error={error} />}>
      <RolesLayout />
    </ErrorBoundary>
  );
}
